<div
  class="rounded-2xl w-full max-w-64 mat-elevation-z8 h-fit bg-white overflow-hidden flex flex-col relative"
>
  <!-- Top decorative line -->
  <div class="h-1 w-full bg-gradient-to-r from-red-600 to-blue-600"></div>

  <!-- Title -->
  <div
    class="text-center py-4 font-bold border-b border-gray-200 flex justify-center items-center gap-2 bg-gray-50 text-gray-800"
  >
    <span class="tracking-[0.15em] text-sm uppercase">{{ title }}</span>
    <app-mini-loader *ngIf="isLoading && !isFirstLoad"></app-mini-loader>
  </div>

  <!-- Skeleton Content (Only visible on first load) -->
  <div *ngIf="isFirstLoad" class="p-4 flex flex-col gap-4 animate-pulse">
    <div class="h-4 bg-gray-200 rounded w-2/3"></div>
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <div class="w-4 h-4 bg-gray-200 rounded-sm"></div>
        <div class="h-3 bg-gray-200 rounded w-1/2"></div>
      </div>
      <div class="flex items-center gap-2">
        <div class="w-4 h-4 bg-gray-200 rounded-sm"></div>
        <div class="h-3 bg-gray-200 rounded w-2/3"></div>
      </div>
      <div class="flex items-center gap-2">
        <div class="w-4 h-4 bg-gray-200 rounded-sm"></div>
        <div class="h-3 bg-gray-200 rounded w-1/3"></div>
      </div>
      <div class="flex items-center gap-2">
        <div class="w-4 h-4 bg-gray-200 rounded-sm"></div>
        <div class="h-3 bg-gray-200 rounded w-1/2"></div>
      </div>
    </div>
  </div>

  <!-- Actual Content (Hidden on first load) -->
  <div
    *ngIf="!isFirstLoad"
    class="flex flex-col w-full transition-opacity duration-300"
    [ngClass]="{ 'opacity-40 pointer-events-none': isDisabled }"
  >
    <ng-content></ng-content>
  </div>
</div>
